export function rgbaToHex(rgba) {
  if (!rgba) return;
  const [r, g, b, a] = rgba.match(/(\d*\.?\d+)/g).map(Number);
  const hex = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  return hex;
}

export const MODULE_SORTING_COL = {
  1: { flex: "0 0 100%", maxWidth: "100%" },
  3: { flex: "0 0 33.3333333333%", maxWidth: "33.3333333333%" },
  5: { flex: "0 0 20%", maxWidth: "20%" },
  7: { flex: "0 0 14%", maxWidth: "14%" },
  9: { flex: "0 0 11%", maxWidth: "11%" }
};

export const PACKAGE_TYPE_SELECT = [
  {
    label: "Tất cả",
    value: -1
  },
  {
    label: "Đơn thường",
    value: 0
  },
  {
    label: "Đơn HVC",
    value: 6
  },
  {
    label: "Đơn nhỏ",
    value: 7
  },
  {
    label: "Đơn dễ vỡ",
    value: 8
  },
  {
    label: "Đơn giá trị cao",
    value: 9
  },
  {
    label: "Đơn nông sản",
    value: 10
  },
  {
    label: "Đơn nguyên hộp",
    value: 11
  },
  {
    label: "Đơn thư tín",
    value: 12
  },
  {
    label: "Đơn ECO",
    value: 18
  }
];

export const WheelChuteOutputType = {
  1: "Tất cả",
  2: "Nhập chuồng",
  3: "Xuất xe",
  4: "Reject",
  5: "Zone A",
  6: "Zone B",
  7: "HVC và Hàng dễ vỡ",
  8: "Sorting",
  9: "Không đích",
  10: "Máng phụ",
  11: "Không đọc được",
  12: "Hàng BigSize",
  13: "Đi thẳng"
};

export const WheelInductionType = {
  1: "INBOUND",
  2: "INHOUSE",
  3: "OUTBOUND",
  4: "INBOUND_CBS"
};

// Action constants
const MODULE_NAME = "WMS/";

// Actions type
export const WMS_GET_SORTING_DEVICES = `${MODULE_NAME}GET_SORTING_DEVICES`;
export const WMS_GET_STATIONS = `${MODULE_NAME}GET_STATIONS`;
export const WMS_GET_PROVINCES = `${MODULE_NAME}GET_PROVINCES`;
export const WMS_GET_USERS = `${MODULE_NAME}GET_USERS`;
export const WMS_GET_CROSSBELT_INBOUND_RATE = `${MODULE_NAME}GET_CROSSBELT_INBOUND_RATE`;
export const WMS_GET_CROSSBELT_SCANNER_RATE = `${MODULE_NAME}GET_CROSSBELT_SCANNER_RATE`;
export const WMS_GET_CROSSBELT_STATISTIC_SORTING = `${MODULE_NAME}GET_CROSSBELT_STATISTIC_SORTING`;
export const WMS_GET_CROSSBELT_STATISTIC_INDUCTION = `${MODULE_NAME}GET_CROSSBELT_STATISTIC_INDUCTION`;
export const WMS_GET_CROSSBELT_STATISTIC_SORTING_TOTAL = `${MODULE_NAME}GET_CROSSBELT_STATISTIC_SORTING_TOTAL`;
export const WMS_GET_CROSSBELT_STATISTIC_INDUCTION_TOTAL = `${MODULE_NAME}GET_CROSSBELT_STATISTIC_INDUCTION_TOTAL`;

export const WMS_GET_WHEEL_SORTING_RATE = `${MODULE_NAME}GET_WHEEL_SORTING_RATE`;
export const WMS_GET_WHEEL_STATISTIC_SORTING = `${MODULE_NAME}GET_WHEEL_STATISTIC_SORTING`;
export const WMS_GET_WHEEL_STATISTIC_INDUCTION = `${MODULE_NAME}GET_WHEEL_STATISTIC_INDUCTION`;
export const WMS_GET_WHEEL_STATISTIC_SORTING_TOTAL = `${MODULE_NAME}GET_WHEEL_STATISTIC_SORTING_TOTAL`;
export const WMS_GET_WHEEL_STATISTIC_INDUCTION_TOTAL = `${MODULE_NAME}GET_WHEEL_STATISTIC_INDUCTION_TOTAL`;
